<div *ngIf="state === 'ready'">
    <div class="row">
        <div class="col-11">
            Filter
            <input type="text" (input)="filterPositionTypes($event)" />
        </div>
        <div class="col-1">
            <a (click)="openPositionTypeUpsertPanel(0)" ngbTooltip="Add">
                <i class="fa fa-plus" style="color: blue"></i>
            </a>
        </div>
    </div>
    <hr />

    <div *ngIf="state === 'ready'" class="tcc-table-div">
        <tcc-table tableClass="table-sm small" 
            [rows]="filteredPositionTypes" 
            [columns]="columns" 
            [buttons]="buttons"
            (cellClick)="rowClicked($event)">
        </tcc-table>
    </div>
</div>

